import { userLabel } from '@app/pcs/models/user-label';
import {gql} from 'apollo-angular';

export const userLabelsQuery = gql`
    query UserLabel {
        userLabel {
            ...userLabel
        }
    }
    ${userLabel}
`;

export const dossierLabelsQuery = gql`
    query UserLabel ($dossierId: Long!) {
        userLabel (dossierId: $dossierId) {
            label {
                id
            }
        }
    }
`;

export const isLabelUsedInDossiersQuery = gql`
    query IsLabelUsedInDossiers ($labelId: Long!) {
        isLabelUsedInDossiers (labelId: $labelId)
    }
`;

export const eligibleUsersForSharingQuery = gql`
    query ShareEligibleUsers($labelId: Long!) {
        eligibleUsersForSharing(labelId: $labelId) {
            id
            name
            firstName
        }
    }
`;

export const sharedUsersQuery = gql`
    query SharedUsers($labelId: Long!) {
        sharedUsers(labelId: $labelId) {
            id
            name
            firstName
        }
    }
`;
